import { render, staticRenderFns } from "./company-mng.vue?vue&type=template&id=d031d4b6"
import script from "./company-mng.vue?vue&type=script&lang=js"
export * from "./company-mng.vue?vue&type=script&lang=js"
import style0 from "./company-mng.vue?vue&type=style&index=0&id=d031d4b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports